import { IconContainer } from "@src/components/helper.styled";

const ReportsIcon = () => {
	return (
		<IconContainer>
			<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0 0V4.66667H0.607143C1.33025 4.66667 1.82143 5.206 1.82143 6C1.82143 6.794 1.33025 7.33333 0.607143 7.33333H0V12H17V7.33333H16.3929C15.6698 7.33333 15.1786 6.794 15.1786 6C15.1786 5.206 15.6698 4.66667 16.3929 4.66667H17V0H0ZM1.21429 1.33333H15.7857V3.45867C14.7445 3.758 13.9643 4.76333 13.9643 6C13.9643 7.23667 14.7445 8.242 15.7857 8.542V10.6667H1.21429V8.54133C2.25554 8.242 3.03571 7.23667 3.03571 6C3.03571 4.76333 2.25554 3.758 1.21429 3.458V1.33333Z"
					fill="white"
				/>
			</svg>
		</IconContainer>
	);
};

export default ReportsIcon;
